import React from 'react';
import { Badge as AntdBadge } from 'antd';

const Badge = ({ count, showZero = true, color = 'var(--gray-700)', ...rest }) => {
  return <AntdBadge count={count} showZero={showZero} color={color} {...rest} />;
};

export default Badge;
